//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions, mapGetters } from 'vuex';
import BasePage from './base.vue';
import bindPhonePage from './bind-phone.vue';
import pageSuccess from './page-success';
import weixinPage from './weixin.vue';
import * as types from '~/types';

export default {
  components: {
    BasePage,
    pageSuccess,
    weixinPage,
    bindPhonePage,
  },
  data() {
    return {
      page: 'base',
      type: null,
    };
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'bindWechatInfo']),
    ...mapState('user', [
      'isLoginFormShow',
      'isRegistFirst',
      'isLogin',
      'loginInfo',
    ]),
  },
  watch: {
    isLoginFormShow(isShow) {
      if (!isShow) {
        this.page = 'base';
        this.type = null;
      }
      if (this.isLogin && !this.loginInfo.phone && this.bindWechatInfo) {
        this.page = 'bindphone';
      }
    },
  },
  beforeMount() {
    const query = this.$route.query;
    if (query && query.wxcode) {
      this.page = 'bindphone';
    }
  },
  beforeDestroy() {
    this.page = 'base';
    this.type = null;
  },
  methods: {
    ...mapMutations('user', {
      hide: types.HIDE_LOGIN_FORM,
    }),
    ...mapActions('user', {
      logout: types.LOGOUT,
    }),
    /**
     * @description 关闭登陆弹窗
     */
    closeLogin() {
      if (this.page === 'bindphone' && !this.isLogin) {
        this.logout();
      } else {
        this.hide();
      }
    },
    /**
     * @description 修改页面触发时间
     */
    changePage(obj) {
      this.page = obj.page;
      this.type = obj.type || null;
    },
  },
};
